// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function SpeakerSimpleSlashBoldIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M30 11v10a1.5 1.5 0 1 1-3 0V11a1.5 1.5 0 1 1 3 0Zm-2.89 14.991a1.498 1.498 0 0 1-.595 2.436 1.5 1.5 0 0 1-1.625-.418L20.5 23.18V28a1.5 1.5 0 0 1-2.421 1.184L9.485 22.5H4A2.5 2.5 0 0 1 1.5 20v-8A2.5 2.5 0 0 1 4 9.5h4.064L4.89 6.009A1.5 1.5 0 1 1 7.11 3.99l20 22Zm-9.61-6.116L10.791 12.5H4.5v7H10a1.5 1.5 0 0 1 .921.316l6.579 5.117v-5.058ZM15.731 8.437 17.5 7.063v4.8a1.5 1.5 0 1 0 3 0V4a1.5 1.5 0 0 0-2.421-1.184L13.89 6.075a1.5 1.5 0 1 0 1.841 2.368v-.005ZM24 18.867a1.5 1.5 0 0 0 1.5-1.5V13a1.5 1.5 0 1 0-3 0v4.367a1.5 1.5 0 0 0 1.5 1.5Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
